export enum AssetProviderType {
  wonda = 'WondaVR',
  kaltura = 'Kaltura',
  youtube = 'YouTube',
  readyPlayerMe = 'ReadyPlayerMe',
  ibm = 'IBM'
}
